<div id="mi-declarations" class="mi-declarations" tabindex="-1" miFocusOnTab>
    @if (this.formisForm.fields.length> 0) {
    <div id="mi-declarations-content" class="container">
        <div class="row justify-content-center">

            <div class=" col-12 mi-panel-wrraper  standart">
                <div class="mi-panel-content">
                    <div class="mc-my-3">
                        <span class="mi-header">{{tabsText.declarations}}</span>

                    </div>

                    <div class="mi-white-panel with-shadow">

                        <div class="mi-back ">
                            <i class="pi pi-fw pi-chevron-right"></i>
                            <span (click)="back()" id="mi-declarations-back" tabindex="0" role="button"
                                (keyup.enter)="back()">{{genericText?.back}}
                            </span>
                        </div>


                        <mc-field-form [formisForm]="formisForm">
                        </mc-field-form>

                    </div>
                </div>
                <div class="row justify-content-center    justify-content-md-start ">
                    <div class=" mi-next blue-button col-md-3 col-12" id="mi-declarations-sent">
                        <mc-button [label]="genericText?.send" (click)="send()"></mc-button>
                    </div>

                </div>
            </div>
        </div>


    </div>
    }
    @else{
    <div id="mi-declarations-loaded">
        <mi-genral-skeleton></mi-genral-skeleton>
    </div>
    }

    <mc-dialog [dialogProperties]="dialogProperties">
        <mi-send-dialog [unionReqiestId]="unionReqiestId" [isSuccessSend]="isSuccessSend"></mi-send-dialog>
    </mc-dialog>

</div>